<template>
  <div class="clients-container">
    <nuxt-link
      :to="firm.link"
      class="clients-container-box fade-up-animation"
      v-for="(firm, index) in firms"
      :key="index"
      :target="firm.link.startsWith('http') ? '_blank' : '_self'"
      rel="noopener noreferrer"
      :aria-label="
        firm.link.startsWith('http')
          ? `Visit ${firm.logo.split('/')[3]?.split('.')[0]} website`
          : 'Learn more about our clients'
      ">
      <nuxt-img
        :key="index"
        :src="firm.logo"
        class="trusted-by-logo"
        :alt="firm.logo.split('/')[3]?.split('.')[0] + ' logo'" />
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
const firms = [
  {
    logo: '/assets/clients/triglav.svg',
    link: 'https://www.triglav.mk/',
  },
  {
    logo: '/assets/clients/A1.svg',
    link: 'https://a1.mk/',
  },
  {
    logo: '/assets/clients/sparkasse.svg',
    link: 'http://sparkasse.mk/',
  },
  {
    logo: '/assets/clients/hommex.svg',
    link: 'https://hommex.co/',
  },
  {
    logo: '/assets/clients/VoltCards.svg',
    link: 'https://voltcards.com/',
  },
  {
    logo: '/assets/clients/WVP.svg',
    link: 'https://wvp.mk/',
  },
  {
    logo: '/assets/clients/NXP.svg',
    link: 'https://nxp.mk/',
  },
  {
    logo: '/assets/clients/swiftWithADot.svg',
    link: '/about#clients',
  },
  {
    logo: '/assets/clients/AMB.svg',
    link: '/about#clients',
  },
  {
    logo: '/assets/clients/leadifyIt.svg',
    link: 'https://leadifyit.com/',
  },
  {
    logo: '/assets/clients/greenDeli.svg',
    link: 'https://greendeli.mk/',
  },
  {
    logo: '/assets/clients/elmundo.svg',
    link: 'https://elmundo.com.mk/',
  },
  {
    logo: '/assets/clients/spgExpress.svg',
    link: 'https://spgexpress.com/',
  },
  {
    logo: '/assets/clients/vitalBlog.svg',
    link: '/about#clients',
  },
];
</script>
